import React from "react";

/**
 * @param {{ height?: number; width?: number }} props
 */
const RockporchMountainIcon = (props) => {
    return (
        <svg
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 118.57 89.25"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g data-name="Layer 1">
                <g>
                    <path
                        fill="#051123"
                        d="M8.55,40.56C-.39,37.24-1.21,27.65,1.09,22.18,8.2,5.6,32.74-1.07,50.06.14c27.35,1.91,30.16,25.28,6.56,33.51-5.31,1.87-12.72,3.04-19.63,3.47,8.78,5.93,17.83,11.04,23.41,9.71,3.28-.78,1.33,8.51-7.53,7.18-7.02-1.09-16.23-7.1-24.42-13.11-2.22,4.41-3.74,8.43-4.06,11.24-.12,1.09-1.29,1.05-2.3.62-5.89-2.46-4.49-9.75-.86-17.32-1.4-1.09-2.77-2.11-4.02-3.04-2.81-2.18,2.07-7.84,5.27-5.58.82.58,1.68,1.17,2.54,1.8,3.78-6.09,8.04-11.43,9.99-13.5,3.74-4.02,14.44-2.3,10.53,1.44-3.4,3.28-7.41,8.35-11,13.85,7.45-.2,15.33-1.72,21.54-4.25,14.4-5.97,15.14-16.85-4.02-18.61-15.14-1.36-38.59,4.14-44.71,16.5-1.76,3.51-.94,9.52,8.15,11.39,2.11.43-.55,7.49-6.94,5.11Z"
                    />
                    <path
                        fill="#051123"
                        d="M47.08,57.64c7.1-16.62,31.64-22.67,48.96-21.46,27.35,1.91,30.12,25.44,6.52,33.67-6.24,2.18-16.97,4.37-26.34,3.74-3.16,5.7-5.5,11.16-5.89,14.75-.12,1.09-1.29,1.05-2.3.62-5.85-2.46-4.53-9.68-.9-17.21-2.3-.9-4.29-2.11-5.81-3.74-4.68-5.03,1.01-12.17,2.96-8.39,1.33,2.57,3.67,4.25,6.59,5.3,3.78-6.12,8.12-11.55,10.07-13.62,3.74-4.02,14.44-2.3,10.53,1.44-3.36,3.2-7.3,8.23-10.85,13.62,7.96,0,16.66-2.11,21.38-4.06,14.4-5.93,15.1-16.82-4.02-18.57-15.14-1.36-38.63,4.14-44.71,16.47-1.76,3.51-8.5,2.85-6.2-2.58Z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default RockporchMountainIcon;
